module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNDMuMzMiIGhlaWdodD0iMjg1LjY4NiIgdmlld0JveD0iMCAwIDM0My4zMyAyODUuNjg2Ij4KICA8cGF0aCBpZD0i44OR44K5XzM1OTEiIGRhdGEtbmFtZT0i44OR44K5IDM1OTEiIGQ9Ik0tMjg1Ljg4LDMwOS45M1YxNTQuMzdMNTcuNDQ5LDI0LjI0NFYxNzkuOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4NS44ODEgLTI0LjI0NCkiIGZpbGw9InJlZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/red_343.svg
// module id = boV/
// module chunks = 0